import React from "react";

import { Skeleton } from "../../../../../ui/skeleton";

type DiaryBookingCardPlaceholderType = {
  index?: number;
};

export const DiaryBookingCardPlaceholder = ({
  index = 1
}: DiaryBookingCardPlaceholderType) => {
  return (
    <div key={`placeholder-${index}`} className="h-auto">
      <div
        className={[
          "DiaryBookingCardPlaceholder",
          "flex w-full flex-row flex-nowrap justify-start content-start items-stretch",
          "overflow-hidden bg-page-background relative h-[89px]",
          "border-b border-panel border-border-color"
        ].join(" ")}
      >
        <div
          className={[
            "DiaryBookingCardPlaceholder__state",
            "flex-none w-[30px] flex justify-center items-center rounded-sm",
            "m-panel-padding bg-[var(--panelBackgroundAlt)]",
            "relative overflow-hidden",
            "[[data-theme='Light']_&]:bg-[#e8eaec]"
          ].join(" ")}
        >
          <span
            className={[
              "BookingStage_Label",
              "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
              "z-[2] text-[13px] font-bold text-primary-color",
              "flex items-center justify-center w-6 h-6"
            ].join(" ")}
          >
            <Skeleton className="w-[12px] h-[12px]" />
          </span>
          <div
            className={[
              "BookingStage_Colour",
              "absolute top-0 left-0 w-full h-full rounded-sm z-[1]"
            ].join(" ")}
          >
            <Skeleton className="w-full h-full" />
          </div>
        </div>
        <div
          className={[
            "DiaryBookingCardPlaceholder__details",
            "flex-auto overflow-hidden my-panel-padding",
            "flex flex-col justify-evenly mt-3"
          ].join(" ")}
        >
          <div
            className={[
              "DiaryBookingCardPlaceholder__detailsName",
              "font-bold overflow-hidden whitespace-nowrap text-ellipsis",
              "text-primary-color"
            ].join(" ")}
          >
            <Skeleton className="w-[150px] h-[14px]" />
          </div>
          <div
            className={[
              "DiaryBookingCardPlaceholder__detailsTable",
              "text-[0.8em] overflow-hidden whitespace-nowrap text-ellipsis",
              "flex items-center"
            ].join(" ")}
          >
            <Skeleton className="w-[120px] h-[14px]" />
          </div>
          <div
            className={[
              "DiaryBookingCardPlaceholder__detailsType",
              "text-[var(--tertiaryColor)] overflow-hidden whitespace-nowrap",
              "text-ellipsis text-[0.8em]"
            ].join(" ")}
          >
            <Skeleton className="w-[70px] h-[14px]" />
          </div>
        </div>
        <div
          className={[
            "DiaryBookingCardPlaceholder__aux",
            "flex-none w-[100px] m-panel-padding flex flex-col"
          ].join(" ")}
        >
          <div
            className={[
              "DiaryBookingCardPlaceholder__auxTime",
              "font-bold text-ellipsis text-right overflow-hidden",
              "whitespace-nowrap flex justify-end grow"
            ].join(" ")}
          >
            <Skeleton className="w-[30px] h-[14px]" />
          </div>
          <div
            className={[
              "DiaryBookingCardPlaceholder__auxZone",
              "overflow-hidden whitespace-nowrap text-ellipsis",
              "text-[var(--tertiaryColor)] grow text-[0.8em] justify-end flex"
            ].join(" ")}
          >
            <Skeleton className="w-[50px] h-[14px]" />
          </div>
          <div
            className={[
              "DiaryBookingCardPlaceholder__auxPeople",
              "font-bold text-[0.8em] opacity-80 overflow-hidden",
              "whitespace-nowrap text-ellipsis flex justify-end grow"
            ].join(" ")}
          >
            <Skeleton className="w-[20px] h-[14px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
